import { _UserCustomAction } from "../user-custom-actions/types.js";
import { getValueForUICultureBinder } from "./funcs.js";
_UserCustomAction.prototype.titleResource = getValueForUICultureBinder("titleResource");
_UserCustomAction.prototype.descriptionResource = getValueForUICultureBinder("descriptionResource");
//# sourceMappingURL=user-custom-actions.js.map